import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectInitialLoad, selectUser } from '../containers/App/selectors';

const useIsAdmin = () => {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const initialLoad = useSelector(selectInitialLoad);

  useEffect(() => {
    if (!initialLoad) {
      return;
    }

    if (!user) {
      navigate('/');
    } else if (!user.isAdmin) {
      navigate('/statistics');
    }
  }, [navigate, user, initialLoad]);

  return { user, initialLoad };
};

export { useIsAdmin };
